import axios from "axios";

export const url = {
  apiBaseUrl: "https://isecure.srashtasoft.in",   //Development Server
  // apiBaseUrl: "https://admin.isecureapps.com",  // Production Server
};

export const axiosInstance = axios.create({
  baseURL: "https://isecure.srashtasoft.in/",   //Development Server
  // baseURL: "https://admin.isecureapps.com",   // Production Server
});
